module.exports = __webpack_public_path__ + "img/orders60.29e99b88.png";